import React from 'react'
import serviceData from './../data/serviceData.json';
import { Link } from 'react-router-dom';
const ServiceList = () => {
    const services = serviceData;
    const serviceSlugs = {
    1: "residential-interior-design",
    2: "Furniture-And-Home-Decor",
    3: "Commercial-Interior-Design",
    4: "Interior-Lighting-Design",
    5: "home-interior-colour",
    6: "Best-3D-Home-Interior-designer"
};
    return (
        <>
            {/* Our Services Section Start */}
            <div className="page-services">
                <div className="container">
                    <div className="row">
                        {/* Service Item Dynamic */}
                        {services.map((service, index) => (
                            <div className="col-lg-4 col-md-6" key={index}>
                                <div className="service-item wow fadeInUp">
                                    <div className="service-image" style={{ position: "relative" }}>
                                        <Link to={`/services/${serviceSlugs[service.id]}`} data-cursor-text="View">
                                            <div className="square-img-wrapper">
                                                <figure className="image-anime">
                                                    <img src={service.image} alt={service.title} />
                                                </figure>
                                            </div>
                                        </Link>
                                        {/* Text over image */}
                                        <div className="service-overlay-text">
                                            <h3>
                                                <a href="#!" style={{ color: "black" }}>
                                                    {service.title}
                                                </a>
                                            </h3>
                                            <p>
                                                {service.info}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="service-btn">
                                       <Link to={`/services/${serviceSlugs[service.id]}`}>
                                            <img src="images/arrow-white.svg" alt="" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}    
                    </div>
                </div>
            </div>
            {/* Our Services Section End */}
        </>
    )
}

export default ServiceList
